/**
 * Утилиты для форматирования чисел (RU версия)
 * Чистые функции без зависимостей от Vue
 */

/**
 * Форматирует число с пробелами (разделитель тысяч)
 * @param {Number|String} x - число для форматирования
 * @returns {String}
 */
export function numberWithSpaces(x) {
  if (x === null || x === undefined || x === '') {
    return '0';
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/**
 * Форматирует число с пробелами, округляя вниз до целого
 * @param {Number|String} x - число для форматирования
 * @returns {String}
 */
export function numberWithSpacesCeil(x) {
  if (x === null || x === undefined || x === '') {
    return '0';
  }
  const y = Math.floor(+x);
  return y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/**
 * Форматирует число с пробелами и фиксированным количеством знаков после запятой
 * @param {Number|String} x - число для форматирования
 * @param {Number} step - количество знаков после запятой
 * @returns {String}
 */
export function numberWithSpacesFixed(x, step = 2) {
  if (x === null || x === undefined || x === '') {
    return '0.' + '0'.repeat(step);
  }
  const y = (+x).toFixed(step);
  return y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/**
 * Форматирует число с пробелами, округляя вниз и фиксируя 2 знака после запятой
 * @param {Number|String} x - число для форматирования
 * @returns {String}
 */
export function numberWithSpacesCeilFix2(x) {
  if (x === null || x === undefined || x === '') {
    return '0.00';
  }
  const y = Math.floor(+x);
  const z = y.toFixed(2);
  return z.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/**
 * Форматирует число с пробелами и 2 знаками после запятой
 * @param {Number|String} x - число для форматирования
 * @returns {String}
 */
export function numberWithSpacesFix2(x) {
  if (x === null || x === undefined || x === '') {
    return '0.00';
  }
  if (typeof x !== 'number') {
    x = Number(x);
  }
  return x
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
